<template>
  <cms-shell :data="data" title="Instagram Grid" @up="$emit('up', -1, data)" @down="$emit('down', 1, data)" @remove="$emit('remove', data)">
  </cms-shell>
</template>

<script>
    import CmsShell from "./CmsShell";

    export default {
      components: {CmsShell},
      name: "cms-instagramgrid",
      props:['data']
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cms/CmsInstagramGrid.vue